module.exports = __webpack_public_path__ + "static/media/21.b4a81ba2.png";